<template>
  <div>
    <div style="float: right">
      <v-btn icon @click="onClose(false)"><v-icon>close</v-icon></v-btn>
    </div>
    <div class="pa-5">
      <h1 class="primary--text">จัดการแคมเปญ</h1>
      <v-layout wrap>
        <v-flex xs4 sm4 class="form-control" style="align-self: center"> ชื่อแคมเปญ </v-flex>
        <v-flex xs8 sm8 class="form-control">
          <input
            v-model="input.name"
            v-validate="'required'"
            class="form-control"
            type="text"
            name="ชื่อแคมเปญ"
          />
          <div :class="{ 'has-error form-control': errors.has('ชื่อแคมเปญ') }">
            <span v-if="errors.has('ชื่อแคมเปญ')" class="text-error">{{
              errors.first('ชื่อแคมเปญ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs4 sm4 class="form-control" style="align-self: center"> ประเภทแคมเปญ </v-flex>
        <v-flex xs8 sm8 class="form-control">
          <multiselect
            v-model="input.type"
            v-validate="'required'"
            placeholder=""
            :show-labels="false"
            label="name"
            track-by="value"
            name="ประเภทแคมเปญ"
            :options="campaignTypes"
          >
            <template #noResult> ไม่พบข้อมูล </template>
          </multiselect>
          <div :class="{ 'has-error form-control': errors.has('ประเภทแคมเปญ') }">
            <span v-if="errors.has('ประเภทแคมเปญ')" class="text-error">{{
              errors.first('ประเภทแคมเปญ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 class="form-control mt-2">
          <span>คำอธิบายแคมเปญ</span>
          <autoresize-textarea
            v-model="input.description"
            v-validate="'required'"
            class="form-control"
            type="text"
            name="คำอธิบายแคมเปญ"
          />
          <div :class="{ 'has-error form-control': errors.has('คำอธิบายแคมเปญ') }">
            <span v-if="errors.has('คำอธิบายแคมเปญ')" class="text-error">{{
              errors.first('คำอธิบายแคมเปญ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 class="mb-2"> ภาพแคมเปญ </v-flex>
        <v-flex xs12 sm12>
          <div class="pb-3 form-control" :class="{ 'has-error': errors.has('campaignImage') }">
            <UploadFile
              id="image"
              v-model="input.image"
              v-validate="'required'"
              :max="1"
              data-vv-name="campaignImage"
              data-vv-as="ภาพแคมเปญ"
            >
              <template #boxForUpload>
                <div
                  style="
                    background: #dddcdc;
                    height: 100px;
                    width: 100%;
                    border-radius: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                  "
                >
                  เลือกไฟล์เพื่ออัพโหลด
                </div>
              </template>
            </UploadFile>
            <span v-show="errors.has('campaignImage')" class="text-error">{{
              errors.first('campaignImage')
            }}</span>
          </div>
        </v-flex>
        <v-flex sm12 xs12 class="mb-2"> ระยะเวลา </v-flex>
        <v-flex xs6 sm6 class="pr-3">
          <span> เริ่ม </span>
          <DatepickerCustomDialog
            v-model="input.startTimestamp"
            v-validate="'required'"
            class="form-control"
            data-vv-name="วันเริ่มแคมเปญ"
            data-vv-as="วันเริ่มแคมเปญ"
          >
            <input
              placeholder="DD/MM/YYYY"
              readonly
              :value="getDateFormatted(input.startTimestamp)"
              type="text"
            />
          </DatepickerCustomDialog>
          <span v-show="errors.has('วันเริ่มแคมเปญ')" class="text-error red--text">{{
            errors.first('วันเริ่มแคมเปญ')
          }}</span>
        </v-flex>
        <v-flex xs6 sm6>
          <span> สิ้นสุด </span>
          <DatepickerCustomDialog
            v-model="input.endTimestamp"
            v-validate="'required'"
            class="form-control"
            data-vv-name="วันสิ้นสุดแคมเปญ"
            data-vv-as="วันสิ้นสุดแคมเปญ"
          >
            <input
              placeholder="DD/MM/YYYY"
              readonly
              :value="getDateFormatted(input.endTimestamp)"
              type="text"
            />
          </DatepickerCustomDialog>
          <span v-show="errors.has('วันสิ้นสุดแคมเปญ')" class="text-error red--text">{{
            errors.first('วันสิ้นสุดแคมเปญ')
          }}</span>
        </v-flex>
        <v-flex xs12 class="form-control mt-2">
          <span>เงื่อนไขแคมเปญ</span>
          <autoresize-textarea
            v-model="input.condition"
            v-validate="'required'"
            class="form-control"
            type="text"
            name="เงื่อนไขแคมเปญ"
          />
          <div :class="{ 'has-error form-control': errors.has('เงื่อนไขแคมเปญ') }">
            <span v-if="errors.has('เงื่อนไขแคมเปญ')" class="text-error">{{
              errors.first('เงื่อนไขแคมเปญ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 class="form-control mt-2">
          <span>เงื่อนไขการแนบใบเสร็จ</span>
          <autoresize-textarea
            v-model="input.receiptCondition"
            v-validate="'required'"
            class="form-control"
            type="text"
            name="เงื่อนไขการแนบใบเสร็จ"
          />
          <div :class="{ 'has-error form-control': errors.has('เงื่อนไขการแนบใบเสร็จ') }">
            <span v-if="errors.has('เงื่อนไขการแนบใบเสร็จ')" class="text-error">{{
              errors.first('เงื่อนไขการแนบใบเสร็จ')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 class="mb-2">
          แบนเนอร์ (แสดงหน้าอัปโหลดใบเสร็จ) <span style="color: red">**สูงสุด 5 ภาพ</span>
        </v-flex>
        <v-flex xs12 sm12>
          <div class="pb-3 form-control" :class="{ 'has-error': errors.has('bannerImage') }">
            <UploadFile
              id="banner"
              v-model="input.banner"
              v-validate="'required'"
              :max="5"
              data-vv-name="bannerImage"
              data-vv-as="แบนเนอร์"
            >
              <template #boxForUpload>
                <div
                  style="
                    background: #dddcdc;
                    height: 100px;
                    width: 100%;
                    border-radius: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                  "
                >
                  เลือกไฟล์เพื่ออัพโหลด
                </div>
              </template>
            </UploadFile>
            <span v-show="errors.has('bannerImage')" class="text-error">{{
              errors.first('bannerImage')
            }}</span>
          </div>
          <div class="red--text">ขนาด 500 * 270 px</div>
        </v-flex>
        <v-flex v-if="input.type && input.type.value == 'collect'" xs12 sm12 class="form-control">
          <span>กำหนดแต้ม/ยอดซื้อ 1 บาท</span>
          <input
            key="collectScore"
            v-model="input.collectScore"
            v-validate="'required'"
            class="form-control"
            type="number"
            min="1"
            max="9999"
            name="กำหนดแต้ม/ยอดซื้อ 1 บาท"
            data-vv-name="collectScore"
            data-vv-as="กำหนดแต้ม/ยอดซื้อ 1 บาท"
            @keypress="keyIsNumber"
          />
          <div :class="{ 'has-error form-control': errors.has('collectScore') }">
            <span v-if="errors.has('collectScore')" class="text-error">{{
              errors.first('collectScore')
            }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 class="form-control">
          <span>จำนวนครั้งที่สามารถเข้าร่วมแคมเปญได้/ผู้ใช้ 1 คน</span>
          <input
            v-model="input.limitParticipation"
            v-validate="'required'"
            class="form-control"
            type="text"
            min="1"
            max="9999"
            data-vv-name="limitParticipation"
            data-vv-as="จำนวนครั้งที่สามารถเข้าร่วมแคมเปญได้/ผู้ใช้ 1 คน"
            @keypress="keyIsNumber"
          />
          <div :class="{ 'has-error form-control': errors.has('limitParticipation') }">
            <span v-if="errors.has('limitParticipation')" class="text-error">{{
              errors.first('limitParticipation')
            }}</span>
          </div>
        </v-flex>
        <v-flex v-if="input.type && input.type.value == 'collect'" sm12 xs12 class="mb-2">
          แต้มหมดอายุ
        </v-flex>
        <v-flex v-if="input.type && input.type.value == 'collect'" xs6 sm6 class="pr-3">
          <span> วันที่ </span>
          <DatepickerCustomDialog
            v-model="expiredRewardDate"
            v-validate="'required'"
            class="form-control"
            data-vv-name="วันที่แต้มหมดอายุ"
            data-vv-as="วันที่แต้มหมดอายุ"
          >
            <input
              placeholder="DD/MM/YYYY"
              readonly
              :value="getDateFormatted(expiredRewardDate)"
              type="text"
            />
          </DatepickerCustomDialog>
          <span v-show="errors.has('วันที่แต้มหมดอายุ')" class="text-error red--text">{{
            errors.first('วันที่แต้มหมดอายุ')
          }}</span>
        </v-flex>
        <v-flex v-if="input.type && input.type.value == 'collect'" xs6 sm6>
          <span> เวลา </span>
          <CustomTimepicker
            v-model="expiredRewardTime"
            v-validate="'required'"
            class="form-control"
            data-vv-name="เวลาแต้มหมดอายุ"
            data-vv-as="เวลาแต้มหมดอายุ"
          >
            <input placeholder="HH:mm" readonly :value="expiredRewardTime" type="text" />
          </CustomTimepicker>
          <span v-show="errors.has('เวลาแต้มหมดอายุ')" class="text-error red--text">{{
            errors.first('เวลาแต้มหมดอายุ')
          }}</span>
        </v-flex>
      </v-layout>

      <div class="form-control">
        <span>ข้อความ Approve ใบเสร็จ</span>
        <autoresize-textarea
          v-model="input.approveMessage"
          v-validate="'required'"
          class="form-control"
          type="text"
          name="ข้อความ Approve ใบเสร็จ"
        />
        <span v-show="errors.has('ข้อความ Approve ใบเสร็จ')" class="text-error red--text">{{
          errors.first('ข้อความ Approve ใบเสร็จ')
        }}</span>
      </div>

      <template v-if="input.type.value == 'lucky_draw'">
        <div :key="luckyCondition">
          <div class="mt-3">เงื่อนไขการได้สิทธิ์</div>
          <v-checkbox
            v-model="luckyCondition"
            :error="errors.has('luckyCondition')"
            label="ตามจำนวนยอดซื้อ/1สิทธิ์"
            value="isPurchaseAmount"
            color="primary"
          ></v-checkbox>
          <div v-if="luckyCondition == 'isPurchaseAmount'" class="default-input">
            <span>ระบุจำนวนยอดซื้อ</span>
            <v-text-field
              id="purchaseAmount"
              v-model="input.purchaseAmount"
              v-validate="{
                required: true,
                numeric: true,
                min_value: 1,
                max_value: 10000000
              }"
              name="purchaseAmount"
              data-vv-as="ระบุจำนวนยอดซื้อ"
              placeholder="ระบุจำนวนยอดซื้อ"
              outline
              type="text"
              :hide-detail="!errors.has('purchaseAmount')"
              :error="errors.has('purchaseAmount')"
              :error-messages="errors.first('purchaseAmount')"
              @keypress="keyIsNumber"
            ></v-text-field>
          </div>
          <v-checkbox
            v-model="luckyCondition"
            label="ตามยอดซื้อขั้นต่ำ"
            value="isMinPurchaseAmount"
            color="primary"
            :error="errors.has('luckyCondition')"
          ></v-checkbox>

          <div v-if="luckyCondition == 'isMinPurchaseAmount'" class="default-input">
            <span>ระบุจำนวนยอดซื้อ</span>
            <v-text-field
              id="minPurchaseAmount"
              v-model="input.minPurchaseAmount"
              v-validate="{
                required: true,
                numeric: true,
                min_value: 1,
                max_value: 10000000
              }"
              name="minPurchaseAmount"
              data-vv-as="ระบุจำนวนยอดซื้อ"
              placeholder="ระบุจำนวนยอดซื้อ"
              outline
              type="text"
              :hide-detail="!errors.has('minPurchaseAmount')"
              :error="errors.has('minPurchaseAmount')"
              :error-messages="errors.first('minPurchaseAmount')"
              @keypress="keyIsNumber"
            ></v-text-field>
            <span>ระบุจำนวนสิทธิ์ที่ได้รับ</span>
            <v-text-field
              id="privilegeAmount"
              v-model="input.privilegeAmount"
              v-validate="{
                required: true,
                numeric: true,
                min_value: 1,
                max_value: 10000000
              }"
              name="privilegeAmount"
              data-vv-as="ระบุจำนวนสิทธิ์ที่ได้รับ"
              placeholder="ระบุจำนวนสิทธิ์ที่ได้รับ"
              outline
              type="text"
              :hide-detail="!errors.has('privilegeAmount')"
              :error="errors.has('privilegeAmount')"
              :error-messages="errors.first('privilegeAmount')"
              @keypress="keyIsNumber"
            ></v-text-field>
          </div>

          <input
            v-model="luckyCondition"
            v-validate="{
              required: true
            }"
            type="hidden"
            name="luckyCondition"
            data-vv-as="เงื่อนไขการได้สิทธิ์"
          />

          <span class="error--text caption">{{ errors.first('luckyCondition') }}</span>
        </div>
      </template>

      <div style="text-align: center">
        <v-btn color="gray" @click="onClose(false)">ยกเลิก</v-btn>
        <v-btn color="primary" @click="saveData">ตกลง</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import UploadFile from './UploadMultipleFile.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    Multiselect,
    UploadFile,
    AutoresizeTextarea,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  props: {
    campaignTypeOps: {
      type: String,
      default: ''
    },
    detail: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      input: {
        id: '',
        name: '',
        type: '',
        description: '',
        image: [],
        startTimestamp: '',
        endTimestamp: '',
        condition: '',
        receiptCondition: '',
        banner: [],
        collectScore: null,
        limitParticipation: '',
        expiredReward: '',
        //lucky draw
        approveMessage: '',
        isPurchaseAmount: false,
        purchaseAmount: 0,
        isMinPurchaseAmount: false,
        minPurchaseAmount: 0,
        privilegeAmount: 0
      },
      expiredRewardDate: '',
      expiredRewardTime: '',
      campaignTypes: [
        { name: 'ซื้อครบ', value: 'full' },
        { name: 'ซื้อสะสม', value: 'collect' },
        { name: 'ซื้อชิงโชค', value: 'lucky_draw' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    luckyCondition: {
      get() {
        if (this.input) {
          if (this.input.isPurchaseAmount == true) return 'isPurchaseAmount'
          if (this.input.isMinPurchaseAmount == true) return 'isMinPurchaseAmount'
        }
        return null
      },
      set(val) {
        console.log(val)
        let param_names = ['isPurchaseAmount', 'isMinPurchaseAmount']
        param_names.forEach((el) => {
          this.input[el] = el == val
        })
      }
    }
  },
  watch: {
    detail(newVal, oldVal) {
      if (newVal != oldVal) {
        this.checkCondition()
      }
    }
  },
  methods: {
    checkCondition() {
      if (this.campaignTypeOps == 'edit') {
        this.input = { ...this.detail }
        this.input.id = this.detail.id
        this.input.name = this.detail.name
        this.input.banner = this.detail.banner
        this.input.description = this.detail.description
        this.input.condition = this.detail.condition
        this.input.image = [this.detail.image]
        this.input.receiptCondition = this.detail.receipt_condition
        this.input.limitParticipation = this.detail.limit_participation
        this.input.startTimestamp = moment(this.detail.start_timestamp).format('YYYY-MM-DD')
        this.input.endTimestamp = moment(this.detail.end_timestamp)
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        this.input.type = this.campaignTypes.find((f) => f.value == this.detail.type)
        this.input.collectScore = this.detail.collect_score
        if (this.detail.expired_reward) {
          this.expiredRewardDate = moment(this.detail.expired_reward).format('YYYY-MM-DD')
          this.expiredRewardTime = moment(this.detail.expired_reward).format('HH:mm')
        }

        this.$set(this.input, 'approveMessage', this.detail.approve_message || '')
        this.$set(this.input, 'isPurchaseAmount', this.detail.is_purchase_amount || false)
        this.$set(this.input, 'purchaseAmount', this.detail.purchase_amount || 0)
        this.$set(this.input, 'isMinPurchaseAmount', this.detail.is_min_purchase_amount || false)
        this.$set(this.input, 'minPurchaseAmount', this.detail.min_purchase_amount || 0)
        this.$set(this.input, 'privilegeAmount', this.detail.privilege_amount || 0)
      }
    },
    async saveData() {
      if (await this.$validator.validateAll()) {
        if (this.campaignTypeOps == 'create') {
          this.createCampaign()
        } else {
          this.editCampaign()
        }
      }
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else return ''
    },
    async clearData() {
      this.input = {
        name: '',
        type: '',
        description: '',
        image: [],
        startTimestamp: '',
        endTimestamp: '',
        condition: '',
        receiptCondition: '',
        banner: [],
        collectScore: null,
        limitParticipation: '',
        expiredReward: '',
        approveMessage: '',
        isPurchaseAmount: false,
        purchaseAmount: 0,
        isMinPurchaseAmount: false,
        minPurchaseAmount: 0,
        privilegeAmount: 0
      }
      this.expiredRewardDate = ''
      this.expiredRewardTime = ''
      await this.$validator.reset()
    },
    onClose(IsGetData) {
      this.clearData()
      this.$emit('close', IsGetData)
    },
    async createCampaign() {
      this.$store.dispatch('loading')
      let payload = {
        ...this.input,
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid
      }

      payload.startTimestamp = moment(payload.startTimestamp).utcOffset('+07:00').toISOString()
      payload.endTimestamp = moment(payload.endTimestamp)
        .utcOffset('+07:00')
        .add(1, 'day')
        .toISOString()
      // payload.startTimestamp += ' 00:00:00'
      // payload.endTimestamp += ' 00:00:00'
      payload.type = this.input.type.value
      payload.image = this.input.image[0]

      if (payload.type == 'collect') {
        this.expiredReward = moment(this.expiredRewardDate).format('YYYY-MM-DD')
        this.expiredReward +=
          ' ' + (this.expiredRewardTime ? this.expiredRewardTime + ':00' : '00:00:00')
        payload.expiredReward = this.expiredReward
      } else {
        payload.expiredReward = null
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postCamapign(payload)
          this.$swal.fire({
            title: 'สร้างแคมเปญสำเร็จ',
            type: 'success'
          })
          this.onClose(true)
        } catch (error) {
          console.error(error)
        } finally {
          this.$store.dispatch('loading')
        }
      } else {
        api.TOAECOUPONCreateCampaign(payload, (err, result) => {
          this.$store.dispatch('loading')
          if (result.responsecode == 200 && result.status) {
            this.$swal.fire({
              title: 'สร้างแคมเปญสำเร็จ',
              type: 'success'
            })
            this.onClose(true)
          }
        })
      }
    },
    async editCampaign() {
      this.$store.dispatch('loading')
      let payload = {
        ...this.input,
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid
      }

      payload.startTimestamp = moment(payload.startTimestamp).utcOffset('+07:00').toISOString()
      payload.endTimestamp = moment(payload.endTimestamp)
        .utcOffset('+07:00')
        .add(1, 'day')
        .toISOString()
      // payload.startTimestamp += ' 00:00:00'
      // payload.endTimestamp += ' 00:00:00'
      payload.type = this.input.type.value
      payload.image = this.input.image[0]

      if (payload.type == 'collect') {
        this.expiredReward = moment(this.expiredRewardDate).format('YYYY-MM-DD')
        this.expiredReward +=
          ' ' + (this.expiredRewardTime ? this.expiredRewardTime + ':00' : '00:00:00')
        payload.expiredReward = this.expiredReward
      } else {
        payload.expiredReward = null
      }

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.putCamapign(this.input.id, payload)
          this.$swal.fire({
            title: 'แก้ไขแคมเปญสำเร็จ',
            type: 'success'
          })
          this.onClose(true)
        } catch (error) {
          console.error(error)
        } finally {
          this.$store.dispatch('loading')
        }
      } else {
        api.TOAECOUPONEditCampaign(payload, (err, result) => {
          this.$store.dispatch('loading')
          if (result.responsecode == 200 && result.status) {
            this.$swal.fire({
              title: 'แก้ไขแคมเปญสำเร็จ',
              type: 'success'
            })
            this.onClose(true)
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/CampaignDetail.vue